import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    newmanuscriptlist: {},
    manuscriptNotification: {},
};

const NewManuscriptSlice = createSlice({
    name: 'newmanuscript',
    initialState,
    reducers: {
        setNewManuscriptList(state, action) {
            state.newmanuscriptlist = action.payload;
        },
        setToast(state, action) {
            state.manuscriptNotification = action.payload;
        },
        // setToast(state, action) {
        //     state.notification = action.payload;
        // },

    },
});



export const ManuscriptListApi = (tokendata, page, limit, search,journal_id) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/submitManuScriptList?page=${page}&limit=${limit}&search=${search}&type=submited&journal_uuid=${journal_id}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setNewManuscriptList(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");


        })

}

export const NewManuscriptuploadFilesApi = (tokendata, uuid, payload) => async (dispatch) => {

    const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/manuscriptupdate/attachMoreFiles/${uuid}`, payload,
        {
            headers: {
                "Authorization": `Bearer ${tokendata}`,
            },
        }
    ).then((res) => {
        console.log(res, "fsdfffdfvfbg")

        dispatch(
            setToast({
                status: true,
                message: res?.data?.message,
            }))

    })
        .catch((err) => {
            console.log(err?.response, "wddssgfbhj");
            dispatch(
                setToast({
                    status: false,
                    message: err?.response?.data?.message,
                })
            )
        })

}

export const AcceptedArticleEditSubmissionApi = (tokendata, uuid, payload) => async (dispatch) => {

    const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/publisher/update/manuscript/${uuid}`, payload,
        {
            headers: {
                "Authorization": `Bearer ${tokendata}`,
            },
        }
    ).then((res) => {
        console.log(res, "fsdfffdfvfbg")

        dispatch(
            setToast({
                status: true,
                message: res?.data?.message,
            }))


    })
        .catch((err) => {
            console.log(err?.response, "wddssgfbhj");
            dispatch(
                setToast({
                    status: false,
                    message: err?.response?.data?.message,
                })
            )
        })

}

export const MoveManuscriptApi = (tokendata, payload) => async (dispatch) => {

    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/ats/manuscriptmoveToRemarks`, payload,
        {
            headers: {
                "Authorization": `Bearer ${tokendata}`,
            },
        }
    ).then((res) => {
        console.log(res, "fsdfffdfvfbg")

        dispatch(
            setToast({
                status: true,
                message: res?.data?.message,
            }))


    })
        .catch((err) => {
            console.log(err?.response, "wddssgfbhj");
            dispatch(
                setToast({
                    status: false,
                    message: err?.response?.data?.message,
                })
            )
        })

}




export const { setNewManuscriptList, setToast } = NewManuscriptSlice.actions;
const NewManuscriptReducer = NewManuscriptSlice.reducer;

export default NewManuscriptReducer;
